<template>
  <div>
    <b-modal
      id="hdtAdminConsoleModal"
      size="xl"
      content-class="menu-bg-blue-transparent-modal hdt-admin-modal"
      title="Hard Drive Tracking Admin Console"
      hide-footer
     
    >
      <b-container fluid>
        <b-tabs align="center" pills card>
          <!-- HDT Group Tab -->
          <b-tab id="hdtgroup" title="HDT Group" active>
            <b-row>
              <b-col>
                <vue-bootstrap4-table
                  :rows="operators"
                  :columns="operatorColumns"
                  :config="operatorConsoleConfig"
                  :classes="classes"
                >
                  <template slot="name" slot-scope="props">
                    <div>
                      <span>{{ props.row.name }}</span>
                    </div>
                  </template>
                </vue-bootstrap4-table>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-container>
    </b-modal>
  </div>
</template>

<style scoped>
.row-input {
  margin: auto;
  width: 60%;
}
.row-label-left-justify {
  text-align: left;
}
.row-label-right-justify {
  text-align: right;
}
.text-input-left-justify {
  text-align: left;
}
</style>

<style>
/* ── HDT Admin Console modal table + tabs ────────────────────── */
.hdt-admin-modal .menu-bg-blue-transparent-modal {
  background: transparent !important;
  color: #063c6d !important;
  text-shadow: none !important;
}
.hdt-admin-modal table { color: #063c6d !important; text-shadow: none !important; }
.hdt-admin-modal thead th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-shadow: none !important;
}
.hdt-admin-modal thead th a,
.hdt-admin-modal thead th svg { color: rgba(6, 60, 109, 0.5) !important; }
.hdt-admin-modal tbody tr { color: #063c6d !important; text-shadow: none !important; }
.hdt-admin-modal tbody tr:hover { background: rgba(6, 60, 109, 0.04) !important; }
.hdt-admin-modal tbody td {
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.08) !important;
  text-shadow: none !important;
}
.hdt-admin-modal .footer-pagination-row td,
.hdt-admin-modal .footer-pagination-row th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  text-shadow: none !important;
}
.hdt-admin-modal .nav-pills .nav-link {
  color: rgba(6, 60, 109, 0.65);
  background: transparent;
  border: 1px solid rgba(6, 60, 109, 0.3);
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  margin: 0 4px;
  transition: background 0.15s;
}
.hdt-admin-modal .nav-pills .nav-link.active {
  background: #063c6d !important;
  color: #fff !important;
  border-color: #063c6d !important;
}
</style>

<script>
import VueBootstrap4Table from 'vue-bootstrap4-table'
import axios from 'axios'
export default {
  name: 'MMP_HDT_AdminConsole',
  components: {
    VueBootstrap4Table
  },
  data() {
    return {
      formSubmitErrors: [],
      entryManagerRows: [],
      operatorColumns: [
        {
          label: 'Name',
          name: 'name',
          sort: false
        }
      ],
      operatorConsoleConfig: {
        checkbox_rows: false,
        rows_selectable: true,
        card_mode: false,
        global_search: {
          placeholder: 'Search...',
          visibility: true,
          showClearButton: true,
          searchOnPressEnter: true
        },
        highlight_row_hover_color: 'rgba(6,60,109,0.04)',
        show_refresh_button: false,
        show_reset_button: false
      },
      operators: [],
      classes: {
        table: {
          'menu-bg-blue-transparent-modal': true
        }
      }
    }
  },
  methods: {
    // Executes when the Entry Manager button is clicked
    getOperators() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/drive_tracking/getHdtOperators', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            // If duplicate entry found, throw error and prevent submission
            if (content.errors) {
              console.log('Operator API Call Error: ' + content.errors)
            } else {
              this.operators = content.rows
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    loadAdminConsole() {
      this.$nextTick(() => {
        this.getOperators()
      })
    }
  }
}
</script>
